// Picks a deterministic color for a tag chip based on its name. Same tag → same color
// every time it's rendered (patient row, details modal, form picker), and two different
// tags on the same patient get different colors so they're visually distinguishable.
// Category-agnostic — driven purely by the tag name hash.

const PALETTE = [
  'bg-blue-100 text-blue-700 border-blue-200',
  'bg-emerald-100 text-emerald-700 border-emerald-200',
  'bg-rose-100 text-rose-700 border-rose-200',
  'bg-amber-100 text-amber-700 border-amber-200',
  'bg-indigo-100 text-indigo-700 border-indigo-200',
  'bg-violet-100 text-violet-700 border-violet-200',
  'bg-teal-100 text-teal-700 border-teal-200',
  'bg-pink-100 text-pink-700 border-pink-200',
  'bg-orange-100 text-orange-700 border-orange-200',
  'bg-cyan-100 text-cyan-700 border-cyan-200',
];

// Cheap deterministic string hash → palette index. djb2-flavoured. Lowercases the input
// so casing differences don't shift the color.
function hashIndex(str) {
  let h = 5381;
  const s = String(str || '').toLowerCase();
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) + h + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h) % PALETTE.length;
}

export function tagBadgeClasses(tag) {
  const name = tag && typeof tag === 'object' ? tag.name : tag;
  if (!name) return PALETTE[0];
  return PALETTE[hashIndex(name)];
}

// Deterministic colour for an initials avatar, keyed off a person's name — same person
// always gets the same colour, and different people get visually distinct ones, which helps
// the eye recognise a row at a glance. Reuses the tag palette for a consistent look.
export function nameAvatarClasses(name) {
  if (!name) return PALETTE[0];
  return PALETTE[hashIndex(name)];
}

// First+last initials (max 2 chars) from a full name, e.g. "Fatima Sohail" → "FS".
export function nameInitials(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
